/**
 * Bayi sipariş listesi (dealer_sessions) cari bakiye hesapları.
 * remaining = toplam - ödenen (negatif → bayi alacaklı / fazla ödeme)
 */
export const getDealerSessionEffectiveTotal = (session) => {
  if (session?.manualTotalOverride != null && session.manualTotalOverride !== '') {
    return parseFloat(session.manualTotalOverride) || 0;
  }
  return parseFloat(session?.totalOrderAmount || 0) || 0;
};

export const getDealerSessionRemaining = (session) => {
  const total = getDealerSessionEffectiveTotal(session);
  const paid = parseFloat(session?.paidAmount || 0) || 0;
  return total - paid;
};

export const aggregateDealerSessionBalances = (sessions = [], directPayments = []) => {
  const grandTotal = sessions.reduce((sum, session) => sum + getDealerSessionEffectiveTotal(session), 0);
  const sessionPaid = sessions.reduce((sum, session) => sum + (parseFloat(session?.paidAmount || 0) || 0), 0);
  const directPaid = (Array.isArray(directPayments) ? directPayments : []).reduce(
    (sum, p) => sum + (parseFloat(p?.amount || 0) || 0),
    0
  );
  const grandPaid = sessionPaid + directPaid;
  const netBalance = grandTotal - grandPaid;

  return {
    grandTotal,
    sessionPaid,
    directPaid,
    grandPaid,
    netBalance,
    openBalance: Math.max(0, netBalance),
    creditBalance: Math.max(0, -netBalance),
    isCreditor: netBalance < -0.009,
    isBalanced: Math.abs(netBalance) < 0.01
  };
};

export const formatDealerBalanceLabel = (remaining) => {
  if (remaining < -0.009) {
    return { type: 'credit', label: 'Alacaklı', amount: Math.abs(remaining) };
  }
  if (remaining > 0.009) {
    return { type: 'debt', label: 'Kalan', amount: remaining };
  }
  return { type: 'balanced', label: 'Dengede', amount: 0 };
};
